<template>
  <div class="queryBooth">
    <div class="queryBooth-modal">
      <a-alert
        v-if="!isExist&&!isBind"
        banner
      >
        <div slot="message">
          {{ $t('chooseBooth.no_booth_err') }}
          <span v-if="isAllowCreateExnum">
            {{ $t('chooseBooth.，可点击') }}
            <span
              class="red"
              @click="$router.push('/addBooth')"
            >{{ $t('chooseBooth.新增展位') }}</span>
          </span>
        </div>
      </a-alert>
      <a-alert
        v-if="isBind&&isExist&&warnMsg"
        banner
      >
        <div slot="message">
          {{ warnMsg }}
          <!-- {{ $t('chooseBooth.展位') }}: {{ relationExnum }}
          {{ $t('chooseBooth.已被关联') }} -->
        </div>
      </a-alert>
      <div class="queryBooth-modal-form">
        <label>{{ $t('chooseBooth.exnum_label') }}:</label>
        <a-input
          v-model="exnum"
          :placeholder="$t('chooseBooth.exnum_placeholder')"
          class="queryBooth-modal-form-ipt"
          :max-length="150"
        />
      </div>
      <div class="boothNo_check_new">
        {{ $t('booklet.form_boothNo_check_new') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['visible'],
  data() {
    return {
      isAllowCreateExnum: false,
      confirmLoading: false,
      exnum: '',
      relationExnum: '',
      exhibitionId: sessionStorage.getItem('exhibitionId'),
      isExist: true,
      isRelate: true,
      isBind: true,
      warnMsg: ''
    }
  },
  mounted() {
    this.allowAddBooth()
  },
  methods: {
    afterClose() {
      this.exnum = ''
      this.warnMsg = ''
      this.isBind = true
      this.isRelate = true
      this.isExist = true
    },
    // 判断是否可以关联展位
    checkRelateBooth() {
      this.confirmLoading = true
      this.$http({
        method: 'get',
        url: `${this.api}a/api/booth/checkBooth?exhibitionId=${
          this.exhibitionId
        }&&booth=${this.exnum.trim()}`
      }).then(res => {
        this.confirmLoading = false
        if (res.data.resultCode === 0 || res.data.resultCode === '0') {
          const data = res.data.data
          this.isExist = data.isExist
          this.isRelate = data.isRelate
          this.isBind = data.isBind
          this.warnMsg = data.msg
          this.relationExnum = this.exnum
          if (!data.isBind && data.isExist) {
            this.boothId = data.booth.id
            this.relateBooth()
          }
        }
      })
    },
    // 添加展位
    relateBooth() {
      this.confirmLoading = true
      this.$http({
        method: 'get',
        url:
          this.api +
          'a/api/booth/bindBooth?boothId=' +
          this.boothId +
          '&&exhibitionId=' +
          this.exhibitionId
      }).then(response => {
        if (response.data.resultCode === 0 || response.data.resultCode === '0') {
          this.$message.success(this.$t('chooseBooth.bind_success'))
          this.confirmLoading = false
          this.$emit('Refresh')
        } else {
          this.$message.error(this.$t('chooseBooth.bind_error'))
        }
      })
    },
    // 是否允许新增展位
    allowAddBooth() {
      this.$http({
        method: 'get',
        url: `${this.api}a/api/exhibitionConfig/get?expoid=${this.exhibitionId}&&configType=CREATE_EXNUM`
      }).then(res => {
        if (res.data.resultCode === 0 || res.data.resultCode === '0') {
          const data = res.data.data.expoConfigs
          if (data.length > 0) {
            if (data[0].configValue === '0') {
              this.isAllowCreateExnum = true
            } else {
              this.isAllowCreateExnum = false
            }
          }
        }
      })
    },
    boothAddClick() {
      if (this.exnum.trim() === '') {
        this.$message.error(this.$t('chooseBooth.exnum_placeholder'))
        return
      }
      this.checkRelateBooth()
    }
  }
}
</script>

<style lang="less" scoped>
.queryBooth-modal {
  .red {
    color: #d10100;
    cursor: pointer;
  }
  .boothNo_check_new{
  color: #d10100;
  font-size: 12px;
  position: relative;
  bottom: 12px;
}
  &-form {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;
    height: 36px;
    line-height: 36px;
    &-ipt {
      width: 350px;
    }
  }
  &-footer {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fee/UseBooth/BoothAdd.vue